import React from "react";
import {useParams} from "react-router-dom";

import {useLevelRealtimeSubV2} from "~/api/hooks/useLevelV2";
import {usePlayerActions} from "~/hooks/usePlayerActions";
import {useHostGameStarter} from "~/routes/page/coop/hooks/useHostGameStarter";

import useZoomControls from "../../../hooks/useZoomControls";
import PlayLevelHtml from "./PlayLevelHtml";
import useLoadCurrentLevel from "./hooks/useLoadCurrentLevel";

const PlayLevelHtmlWrapper: React.FC = () => {
  const {id} = useParams<{id: string}>();
  useLevelRealtimeSubV2({id});
  useZoomControls();
  usePlayerActions();
  useLoadCurrentLevel();
  useHostGameStarter({levelId: id});

  return (
    <>
      <PlayLevelHtml />
    </>
  );
};

export default PlayLevelHtmlWrapper;
